(function () {
  if (window.__AMWishlistIconSyncInitialized__) return;
  window.__AMWishlistIconSyncInitialized__ = true;

  const OBSERVE_ROOT_SELECTORS =
    '.categories-tabs-section, .product-grid, .bestseller-slider-section, .shop-the-look__box, results-list, .cart-drawer__wishlist, #cart-drawer .cart-drawer__items';

  function getObserveRoots() {
    const roots = document.querySelectorAll(OBSERVE_ROOT_SELECTORS);
    return roots.length ? Array.from(roots) : [document.body];
  }

  function isWishlistActive(engine) {
    if (!(engine instanceof HTMLElement)) return false;
    if (engine.getAttribute('data-added') === 'true') return true;
    const button = engine.querySelector('.wishlist-engine-button');
    return button instanceof HTMLElement && button.getAttribute('data-added') === 'true';
  }

  function syncEngine(engine) {
    if (!(engine instanceof HTMLElement)) return;
    if (isWishlistActive(engine)) {
      engine.setAttribute('data-am-wishlist-active', 'true');
    } else {
      engine.removeAttribute('data-am-wishlist-active');
    }
  }

  function syncAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.wishlist-engine').forEach(syncEngine);
  }

  function observeEngine(engine) {
    if (!(engine instanceof HTMLElement) || engine.dataset.amWishlistObserved === 'true') return;
    engine.dataset.amWishlistObserved = 'true';
    syncEngine(engine);

    const onEngineChange = function () {
      syncEngine(engine);
    };

    const observer = new MutationObserver(onEngineChange);
    observer.observe(engine, {
      attributes: true,
      attributeFilter: ['data-added'],
    });

    const button = engine.querySelector('.wishlist-engine-button');
    if (button instanceof HTMLElement) {
      const btnObserver = new MutationObserver(onEngineChange);
      btnObserver.observe(button, {
        attributes: true,
        attributeFilter: ['data-added'],
      });
    }
  }

  function observeRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.wishlist-engine').forEach(observeEngine);
  }

  let syncTimer = 0;
  let syncRaf = 0;
  const pendingSyncRoots = new Set();

  function scheduleSync(root) {
    if (root && root.querySelectorAll) {
      pendingSyncRoots.add(root);
    } else {
      getObserveRoots().forEach(function (r) {
        pendingSyncRoots.add(r);
      });
    }

    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      if (syncRaf) return;
      syncRaf = requestAnimationFrame(function () {
        syncRaf = 0;
        const roots = pendingSyncRoots.size ? Array.from(pendingSyncRoots) : getObserveRoots();
        pendingSyncRoots.clear();
        roots.forEach(function (r) {
          observeRoot(r);
          syncAll(r);
        });
      });
    }, 120);
  }

  function nodeHasWishlistEngine(node) {
    if (!(node instanceof HTMLElement)) return false;
    return node.classList.contains('wishlist-engine') || Boolean(node.querySelector('.wishlist-engine'));
  }

  function init() {
    getObserveRoots().forEach(function (root) {
      observeRoot(root);
      syncAll(root);
    });

    document.addEventListener('shopify:cart:lines-update', function () {
      scheduleSync();
    });
    document.addEventListener('am:wishlist:changed', function () {
      scheduleSync();
    });
    document.addEventListener('theme-drawer:open', function (ev) {
      if (ev.target instanceof Element) {
        scheduleSync(ev.target);
      } else {
        scheduleSync();
      }
    });

    let moRaf = 0;
    const pendingNodes = new Set();

    const rootObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          pendingNodes.add(node);
        });
      });
      if (moRaf) return;
      moRaf = requestAnimationFrame(function () {
        moRaf = 0;
        let shouldSync = false;
        pendingNodes.forEach(function (node) {
          if (nodeHasWishlistEngine(node)) shouldSync = true;
        });
        pendingNodes.clear();
        if (shouldSync) scheduleSync();
      });
    });

    getObserveRoots().forEach(function (root) {
      rootObserver.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
